import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/components/PageHero";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page not found — Stantive Soft Solutions"
        description="The page you're looking for doesn't exist or has been moved."
        path="/404"
      />
      <PageHero
        eyebrow="404"
        image="/images/hero-home.jpg"
        imagePosition="center"
        title="This page is off the roadmap."
        description="The page you're looking for doesn't exist or has been moved."
        actions={
          <Button
            asChild
            size="lg"
            className="bg-gradient-hero text-primary-foreground shadow-elegant hover:opacity-90"
          >
            <Link to="/">
              <ArrowLeft size={16} className="mr-2" />
              Go Home
            </Link>
          </Button>
        }
      />
    </>
  );
}
